(function() {
    'use strict';

    angular
        .module('dialog-manager')
        .controller('DialogFormCtrl', DialogFormCtrl);

    function DialogFormCtrl(dialogOptions, $timeout, close) {
        const vm = this;
        vm.show = false;
        console.log('DialogFormCtrl loaded');
        vm.options =  dialogOptions;

        vm.dismiss = dismiss;
        vm.submit = submit;

        $timeout(function () {
            vm.show = true;
        });

        function dismiss() {
            close(false);
        }

        function submit() {
            close(vm.getModel());
        }
    }
})();